import { Component, ViewChild } from '@angular/core';
import { RouterModule, Router } from '@angular/router';
import { CommonModule } from '@angular/common';
import { FormBuilder, FormGroup, Validators, ReactiveFormsModule, FormGroupDirective } from '@angular/forms';
import { NgxSpinnerService, NgxSpinnerModule } from 'ngx-spinner';
import { LocalStorageService } from 'ngx-webstorage';
import { NgxTrimDirectiveModule } from 'ngx-trim-directive';
import { NgxMaskDirective } from 'ngx-mask';
import { VerifyService } from '../../services/verify/verify.service';
import { RecaptchaModule, RecaptchaFormsModule } from 'ng-recaptcha-2';
import { MatStepperModule } from '@angular/material/stepper';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { ToastrService } from 'ngx-toastr';
import { Access } from '../../models/access';

@Component({
  selector: 'app-verify',
  templateUrl: './verify.html',
  styleUrls: ['./verify.css'],
  imports: [RouterModule, ReactiveFormsModule, CommonModule, NgxTrimDirectiveModule, NgxMaskDirective, NgxSpinnerModule, RecaptchaModule, RecaptchaFormsModule, MatStepperModule, BsDatepickerModule],
})

export class Verify {

  // Used to clear validation error states on Material form controls
  @ViewChild(FormGroupDirective, { static: false }) formGroupDirective: FormGroupDirective;

  loginInformation: FormGroup;
  authenticate: any;
  message: '';
  submitted = false;
  clicked = false;
  tempVar: number;
  showDivHasFiled: boolean = false;


  constructor(
    private fb: FormBuilder,
    private _router: Router,
    private storage: LocalStorageService,
    private toastr: ToastrService,
    private spinner: NgxSpinnerService,
    private verifyService: VerifyService,

  ) { }
  ngOnInit() {
    this.loginInformation = this.fb.group({
      lucaClaimNumber: ["", Validators.compose([Validators.required, Validators.maxLength(15), Validators.minLength(8), Validators.pattern("^[0-9]+$")])],
      phone1: ['', Validators.compose([Validators.required, Validators.maxLength(10), Validators.minLength(10), Validators.pattern("^[0-9]+$")])],
    })
  }

  get f() { return this.loginInformation.controls; }
  isExpanded = false;

  collapse() {
    this.isExpanded = false;
  }

  toggle() {
    this.isExpanded = !this.isExpanded;
  }
  onSubmit() {
    this.submitted = true;

    // stop here if form is invalid
    if (this.loginInformation.invalid) {
      this.clicked = false;
      return;
    }

    this.clicked = true;
    const au = this.loginInformation.value;

    this.spinner.show();

    this.Login(au);
  }

  Login(au: Access) {
    this.verifyService.verify(au).subscribe({
      next: (res) => {
        this.authenticate = res;

        if (this.authenticate.hasFiled === false) {
          this.storage.store('authenticatedUser', this.authenticate);
          this._router.navigate(['/audit']);
        }
        else if (this.authenticate.hasFiled === true) {
          this.showDivHasFiled = true;

          this.toastr.error('You have already submitted your documents', 'Info Already Saved', {
            timeOut: 5000,
            positionClass: 'toast-bottom-full-width',
            progressBar: true
          });
        }

        // cleanup
        this.spinner.hide();
        this.clicked = false;
        this.loginInformation.reset();
        this.loginInformation.get('lucaClaimNumber').clearValidators();
        this.loginInformation.get('lucaClaimNumber').updateValueAndValidity();
        this.loginInformation.get('phone1').clearValidators();
        this.loginInformation.get('phone1').updateValueAndValidity();
      },

      error: (err) => {
        if (err.status === 404) {
          this.toastr.error('User not found', 'Error', {
            timeOut: 5000,
            positionClass: 'toast-bottom-full-width',
            progressBar: true
          });
        } else {
          this.toastr.error('Something went wrong, Please Check Again', 'Error', {
            timeOut: 5000,
            positionClass: 'toast-bottom-full-width',
            progressBar: true
          });
        }

        this.spinner.hide();
        this.clicked = false;
        this.loginInformation.reset();
      }
    });
  }

}

